import { render, staticRenderFns } from "./purchasePromotional.pug?vue&type=template&id=05b043f1&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./purchasePromotional.scss?vue&type=style&index=0&id=05b043f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b043f1",
  null
  
)

export default component.exports